import { useTranslation } from "react-i18next";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useState } from 'react';
import DisclaimerContent from '../DisclaimerContent';
import DataPrivacyContent from '../DataPrivacyContent';
import LegalInfoContent from "../LegalInfoContent";
import { Modal } from 'react-bootstrap';

function EDMFooter() {
    const [showModal, setShowModal] = useState(false);
    const [modalHeader, setModalHeader] = useState("");
    const [modalContent, setModalContent] = useState("");
    const { t } = useTranslation();

    function handleCloseModal() {
        setShowModal(false);
    }

    function showDisclaimer() {
      setModalHeader(t("Disclaimer"));
      setModalContent(<DisclaimerContent/>);
      setShowModal(true);
    }
  
    function showDataPrivacy() {
      setModalHeader(t("PersonalInformationCollectionStatement"));
      setModalContent(<DataPrivacyContent/>);
      setShowModal(true);
    }
  
    function showImportantLegalInformation() {
      setModalHeader(t("ImportantLegalInformation"));
      setModalContent(<LegalInfoContent/>);
      setShowModal(true);
    }



    return (
        <div>
          <div className="footer-content" style={{color: "white"}}>
            <a href="#/" onClick={showDisclaimer}>{t("Disclaimer")}</a> | <a href="#/" onClick={showDataPrivacy}>{t("PersonalInformationCollectionStatement")}</a> | <a href="#/" onClick={showImportantLegalInformation}>{t("ImportantLegalInformation")}</a>
          </div>
    
          <Modal
            size="lg"
            show={showModal}
            onHide={() => handleCloseModal()}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>
              {modalHeader}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {modalContent}
            </Modal.Body>
          </Modal>
        </div>
    )
}

export default EDMFooter;